module.exports = __webpack_public_path__ + "media/alarm.35d4f2be.mp3";